import React, {useState} from 'react';
import {Alert, Image, TouchableOpacity, View} from 'react-native';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';
import FastImage from 'src/Utils/FastImage';

import {BodyText} from 'src/Modules/CommonView';
import HuntListCard from 'src/Modules/HuntListCard.js';

import Icon from 'react-native-vector-icons/MaterialCommunityIcons';

import {navigationRef} from 'src/Nav/navigationHelpers';
import {useUserInfo} from '../Hooks/reduxHooks';
import CustomActivityIndicator from '../Modules/CommonView/CustomActivityIndicator';
import {setDataAtPath} from '../Utils/fireUtils';

const randomGroupPhotos = [
  'https://firebasestorage.googleapis.com/v0/b/barhuntv2.appspot.com/o/images%2FScavengerHunt%2Fundefined%2F666ea114-d6d9-4b7d-961c-08666921900e?alt=media&token=47df505a-e6b7-4a0c-a1bd-18ba16928faf',
  'https://firebasestorage.googleapis.com/v0/b/barhuntv2.appspot.com/o/images%2FScavengerHunt%2Fundefined%2Ffb8e9bf3-7a52-45cb-aa3d-d5527e330fc5?alt=media&token=caaf51c9-bf32-4a55-90e4-b742e5b1e91d',
  'https://firebasestorage.googleapis.com/v0/b/barhuntv2.appspot.com/o/images%2FScavengerHunt%2Fundefined%2F93d4c141-1189-4973-95ef-630023c05602?alt=media&token=d9d505a6-77bc-4256-9500-1f43ce4d551b',
];

const HuntLeaderboard = ({hunt, leaderboard}) => {
  const {width} = useWindowDimensionsSafe();

  const [noGroups] = useState(false);

  console.log('the leaderboard being rendered is ', leaderboard);

  const admin = useUserInfo('email')?.includes?.('@letsroam.com');
  return (
    <View
      style={{
        flex: 1,
        backgroundColor: global?.color?.white,
        justifyContent: 'center',
      }}>
      <View style={{width, height: 140, position: 'relative', marginBottom: 5}}>
        <HuntListCard
          hideNavigate
          hunt={hunt}
          disableTouch={true}
          hideFlag={true}
          width={width}
          extraMargin={0}
          height={60}
        />
      </View>
      {!!leaderboard?.length &&
        leaderboard?.map?.((group, index) => {
          console.log({group});
          return (
            <View key={index}>
              <GroupRankingTile
                key={`lb_${group.groupId}`}
                name={group.teamName || 'Anonymous Group'}
                score={group.score}
                rank={group.rank}
                backgroundImage={
                  group.teamPhoto && group.teamPhoto != 'hi'
                    ? group.teamPhoto
                    : randomGroupPhotos[(group.rank || 0) % 3]
                }
              />
              {!!admin && (
                <TouchableOpacity
                  onPress={async () => {
                    // pulling the group in indirectly so we do not have to rely on computationally
                    // expensive groups
                    navigationRef.navigate('ConfirmModal', {
                      titleText: `Are you Sure You Want To Flag This Photo!`,
                      confirmText: 'Yes, Flag for Removal!',
                      cancelText: 'Cancel',
                      handleConfirm: () => {
                        const {hunt_id = 'error'} = hunt;
                        const {groupId = 'error', rank = 'error'} = group;
                        const leaderboardAllPath = `scavengerhunt/leaderboard/${hunt_id}/all/${groupId}`;
                        const leaderboardTopPath = `scavengerhunt/leaderboard/${hunt_id}/top10/${
                          parseInt(rank) - 1
                        }`;
                        const groupPath = `scavengerhunt/groups/${groupId}/`;
                        console.log({
                          leaderboardAllPath,
                          leaderboardTopPath,
                          groupPath,
                        });
                        setDataAtPath(leaderboardAllPath, null);
                        setDataAtPath(leaderboardTopPath, null);
                        setDataAtPath(groupPath, null);

                        navigationRef.goBack();
                        Alert.alert(
                          'This Photo Was Flagged For Removal',
                          'We apologize for any inappropriate content. Thank you for helping to keep our community clean. The photo will be gone when you fully close and reopen the app.',
                        );
                      },
                    });
                  }}
                  style={{
                    ...{
                      position: 'absolute',
                      top: 0,
                      right: 5,
                      with: 20,
                      height: 30,
                      zIndex: 100,
                      pointerEvents: 'auto',
                    },
                  }}>
                  <Icon
                    name={'flag'}
                    size={30}
                    color={'red'}
                    // style={{ marginHorizontal: 7 }}
                  />
                </TouchableOpacity>
              )}
            </View>
          );
        })}
      {!leaderboard?.length && !noGroups && (
        <CustomActivityIndicator
          size={'small'}
          color={global?.color?.gray3}
          style={{marginTop: 20}}
        />
      )}
      {!leaderboard?.length && noGroups && (
        <BodyText
          text={
            'Be the first to do this hunt and the top of leaderboard will be yours!'
          }
        />
      )}
    </View>
  );
};

const rankingImages = [
  require('src/Images/Rank/1stPlaceTrophy.png'),
  require('src/Images/Rank/2ndPlaceTrophy.png'),
  require('src/Images/Rank/3rdPlaceTrophy.png'),
  require('src/Images/Rank/star.png'),
];

const rankFormatted = {
  1: '1st',
  2: '2nd',
  3: '3rd',
};

const GroupRankingTile = ({name, score, rank, backgroundImage}) => {
  const imageSource = rank <= 3 ? rankingImages[rank - 1] : rankingImages[3];
  const rankText = rank <= 3 ? rankFormatted[rank] : `${rank}th`;
  const {width} = useWindowDimensionsSafe();
  const formattedPoints = parseInt(score || '0');
  return (
    <View
      style={{
        ...global?.style.boxShadow,
        backgroundColor: global?.color?.white,
        marginVertical: 5,
        marginHorizontal: 10,
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        minHeight: 130,
        width: width - 20,
      }}>
      <View style={{flexDirection: 'row', minHeight: 130}}>
        <View
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
          }}>
          <FastImage
            source={imageSource}
            style={{width: 50, height: 60, marginHorizontal: 10}}
            resizeMode={FastImage?.resizeMode?.contain}
          />
          {rank > 3 && (
            <View style={{position: 'absolute', top: 38}}>
              <BodyText
                text={rankText}
                textStyle={{color: global?.color?.white, fontSize: 14}}
              />
            </View>
          )}
          <BodyText
            text={`${formattedPoints}pts`}
            textStyle={{
              color: global?.color?.gray3,
              fontSize: 12,
              marginTop: 5,
            }}
          />
        </View>
        <View
          style={{
            flex: 1,
            position: 'relative',
            justifyContent: 'flex-end',
          }}>
          {!!backgroundImage &&
            rank < 2 && ( //the first two images
              <FastImage
                source={{uri: backgroundImage}}
                resizeMode={FastImage?.resizeMode?.cover}
                style={{...global?.style.fillAbsolute}}
              />
            )}
          {!!backgroundImage &&
            rank >= 2 && ( //the first two images
              <Image
                source={{uri: backgroundImage}}
                resizeMode={FastImage?.resizeMode?.cover}
                style={{...global?.style.fillAbsolute}}
              />
            )}
          <View
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: global?.color?.gray3_60,
            }}>
            <BodyText
              text={name}
              textStyle={{
                color: global?.color?.white,
                fontSize: 16,
                marginVertical: 0,
                paddingVertical: 5,
                paddingTop: 2,
              }}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

export default HuntLeaderboard;
